///////////////////////////////////////////////////

import { limitOrderFormApiConnector } from 'apiConnector/secondary-market/limit-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { limitOrderInputFormActions } from 'state/secondaryMarket/limit-order/form/input/inputForm.actions';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import type { EpicWithThunk } from 'state/state.common';
import { mapErrorKind } from 'utils/errors/errors';
import type { HttpError } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function reloadLimitOrderTabContentEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { init } = limitOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_RELOAD_FORM_FETCH_REQUESTED'),
      mergeMap(({ request, tabId, workspace }) => {
        return init(request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(response => limitOrderThunks.reloadFormFetchedThunk(tabId, workspace, response)),
          catchError((err: HttpError) =>
            of(
              limitOrderInputFormActions.reloadFormFetchFailed(
                tabId,
                workspace,
                err?.payload?.message,
                mapErrorKind(err),
              ),
            ),
          ),
        );
      }),
    );
  };
}
